import React from "react";

const CardImg = ({ title, subtitle, img, onClickButton, buttonText }) => {
  return (
    <div
      style={{
        borderRadius: "10px",
        border: "1px solid rgba(236, 236, 236, 0.5)",
        background: "#FFFFFF",
        color: "#696969",
        zIndex: 10
      }}
      className="flex flex-col gap-2 mt-10 w-1/3  p-4"
    >
      <img src={img} alt="" />
      <p
        style={{
          fontfamily: "Poppins",
          fontStyle: "normal",
          color: "#26355C",
        }}
        className=" text-xl font-semibold text-left "
      >
        {title}
      </p>
      <p
        style={{
          fontfamily: "Poppins",
          fontStyle: "normal",
          fontWeight: "normal",
          lineHeight: "27px",
          color: "#696969",
          minHeight: "225px"
        }}
        className="text-base text-left"
      >
        {subtitle}
      </p>
      <button
        onClick={onClickButton}
        style={{
          color: "white",
          background: "#DB0090",
          borderRadius: "10px",
          visibility: buttonText ? "show" : "hidden",
        }}
        className="lg:py-2  lg:mt-5 sm:text-lg sm:p-5 "
      >
        { buttonText }
      </button>
    </div>
  );
};

export default CardImg;
